import './RoyaltiesRainAnimation.css';

export default function RoyaltiesRainAnimation({ className }) {
  const classes = className ? `royalties-rain ${className}` : 'royalties-rain';

  return (
    <div className={classes} aria-hidden="true">
      <div className="royalties-rain__stage">
        <span className="royalties-rain__coin royalties-rain__coin--primary" />
        <span className="royalties-rain__coin royalties-rain__coin--secondary royalties-rain__coin--a" />
        <span className="royalties-rain__coin royalties-rain__coin--secondary royalties-rain__coin--b" />
        <span className="royalties-rain__coin royalties-rain__coin--secondary royalties-rain__coin--c" />
        <span className="royalties-rain__glow" />
      </div>
    </div>
  );
}
